module.exports = __webpack_public_path__ + "img/nian_dire.68884315.png";